export default {
  logging: 'Protokollierung ...',
  logCall: 'Anruf protokollieren',
  editLog: 'Protokoll bearbeiten',
  select: 'Übereinstimmenden datensatz auswählen',
  OnHold: 'Wird gehalten',
  Ringing: 'Es wird angerufen',
  CallConnected: 'Anruf verbunden',
  unknownUser: 'Unbekannter Benutzer',
  unknownNumber: 'Anonym',
  unavailable: 'Nicht verfügbar',
  viewDetails: 'Details anzeigen',
};
